var map = {
	"./arrow-left-large.svg": 6730,
	"./arrow-right-large.svg": 1673,
	"./arrow-right.svg": 5395,
	"./arrow-top.svg": 7072,
	"./check.svg": 789,
	"./clock.svg": 7335,
	"./close.svg": 3441,
	"./copy-link.svg": 3021,
	"./difficulty-level.svg": 5525,
	"./list-view-one-column.svg": 107,
	"./list-view-two-columns.svg": 1612,
	"./menu-close.svg": 1441,
	"./menu.svg": 2358,
	"./print.svg": 8008,
	"./search.svg": 4771,
	"./star-empty.svg": 7999,
	"./star-full.svg": 9875,
	"./toggle.svg": 4495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9477;